import { styled } from 'styled-components';

export const AdminNavWrap = styled.div`
  .ant-menu-item {
    color: var(--leftmenu-text-color) !important;
  }
  .ant-menu-item-selected {
    color: var(--leftmenu-active-color) !important;
  }
  .ant-menu-item.ant-menu-item-selected.ant-menu-item-only-child {
    background: var(--leftmenu-highlighter-color) !important;
  }
`;
